var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRelative)?_c('pro-link',{attrs:{"to":{
        name: 'handbook-product-all',
        params: { product: _vm.currentProduct.slug, pathMatch: _vm.requiredVersion + _vm.url.pathname.substr(1) },
        query: Object.fromEntries(_vm.url.searchParams),
        hash: _vm.hash,
    }}},[_vm._t("default")],2):_c('pro-link',{attrs:{"href":_vm.parsedHref}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }